(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click',async(event)=>{
 const anchor=event.target.closest('.pdp-services a[href^="#"]');
 if(anchor){const target=document.querySelector(anchor.getAttribute('href'));if(target?.tagName==='DETAILS')target.open=true}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-code-copy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-promo-copy]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(button.dataset.code);
    } catch (error) {
      const field = document.createElement('textarea');
      field.value = button.dataset.code;
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }
    button.classList.add('is-copied');
    button.setAttribute('aria-label', button.dataset.success);
    status.textContent = button.dataset.success;
    window.clearTimeout(button.copyResetTimer);
    button.copyResetTimer = window.setTimeout(() => {
      button.classList.remove('is-copied');
      button.removeAttribute('aria-label');
      status.textContent = '';
    }, 2800);
  });

  } catch(e) { console.error(e); }
})();
})();
